// extracted by mini-css-extract-plugin
export default {"rootDiv":"style_rootDiv__lsg1l","navigation":"style_navigation__YwIxy"};